import axiosInstance from './axiosInstance';
import config from '../config';
import { StockIssue, CreateStockIssueDto, UpdateStockIssueDto, AvailableStockDto } from '../types/stockIssues.types';

const API_URL = `${config.API_BASE_URL}/StockIssues`;

export const stockIssuesService = {
  getAll: async (
    status?: string,
    warehouseId?: number,
    branchId?: number,
    fromDate?: string,
    toDate?: string
  ): Promise<StockIssue[]> => {
    const params = new URLSearchParams();
    if (status) params.append('status', status);
    if (warehouseId) params.append('warehouseId', warehouseId.toString());
    if (branchId) params.append('branchId', branchId.toString());
    if (fromDate) params.append('fromDate', fromDate);
    if (toDate) params.append('toDate', toDate);
    const url = params.toString() ? `${API_URL}?${params.toString()}` : API_URL;
    const response = await axiosInstance.get<StockIssue[]>(url);
    return response.data;
  },

  getById: async (id: number): Promise<StockIssue> => {
    const response = await axiosInstance.get<StockIssue>(`${API_URL}/${id}`);
    return response.data;
  },

  create: async (stockIssue: CreateStockIssueDto): Promise<StockIssue> => {
    const response = await axiosInstance.post<StockIssue>(API_URL, stockIssue);
    return response.data;
  },

  update: async (id: number, stockIssue: UpdateStockIssueDto): Promise<StockIssue> => {
    const response = await axiosInstance.put<StockIssue>(`${API_URL}/${id}`, stockIssue);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await axiosInstance.delete(`${API_URL}/${id}`);
  },

  postIssue: async (id: number): Promise<StockIssue> => {
    const response = await axiosInstance.post<StockIssue>(`${API_URL}/${id}/post`);
    return response.data;
  },

  unpostIssue: async (id: number): Promise<StockIssue> => {
    const response = await axiosInstance.post<StockIssue>(`${API_URL}/${id}/unpost`);
    return response.data;
  },

  // ✅ NEW: موافقة أمين المخزن (Pending → Draft + إنشاء قيد محاسبي)
  approve: async (id: number): Promise<StockIssue> => {
    const response = await axiosInstance.post<StockIssue>(`${API_URL}/${id}/approve`);
    return response.data;
  },

  // ✅ NEW: رفض أمين المخزن (Pending → Rejected)
  reject: async (id: number, reason?: string): Promise<StockIssue> => {
    const response = await axiosInstance.post<StockIssue>(`${API_URL}/${id}/reject`, { reason });
    return response.data;
  },

  generateIssueNumber: async (): Promise<string> => {
    const response = await axiosInstance.get<string>(`${API_URL}/generate-issue-number`);
    return response.data;
  },

  checkAvailableStock: async (
    itemId: number,
    unitId: number,
    warehouseId: number
  ): Promise<AvailableStockDto> => {
    const response = await axiosInstance.get<AvailableStockDto>(
      `${API_URL}/check-stock?itemId=${itemId}&unitId=${unitId}&warehouseId=${warehouseId}`
    );
    return response.data;
  },
};